import React from 'react';
import { Input } from '@mantine/core';
import ReactPhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneInputField.css';

/**
 * Phone input with country code dropdown.
 * Stores value in E.164 format (e.g. +14165550100).
 * Mirrors Mantine TextInput API: label, description, error, required, disabled.
 */
const PhoneInputField = ({
  label,
  description,
  error,
  required,
  disabled,
  value,
  onChange,
  placeholder,
  styles
}) => {
  return (
    <Input.Wrapper
      label={label}
      description={description}
      error={error}
      required={required}
      styles={styles}
    >
      <ReactPhoneInput
        international
        defaultCountry="CA"
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder || 'Phone number'}
        className={`pdc-phone-input${error ? ' pdc-phone-input--error' : ''}${disabled ? ' pdc-phone-input--disabled' : ''}`}
      />
    </Input.Wrapper>
  );
};

export default PhoneInputField;
